module.exports = __webpack_public_path__ + "static/queveohoy-afb4aadff72bfdebc788e30427cd43cb.png";